import axios from "axios";
import { FormEvent, useState } from "react";
import { MagasinContext } from "../../../Context/MagasinContext";
import { Link } from "react-router-dom";
import SideBareMagasin from "../SideBareMagasin/SideBareMagasin";

export default function (){
      const MagasinId = localStorage.getItem("MagasinId");
  const MagasinName = localStorage.getItem("MagasinName");
      const [Probleme, setProbleme] = useState<string>("");
            const [showSuccessPopup, setShowSuccessPopup] = useState<boolean>(false);
                  const [ShowErreurPopup, setShowErreurPopup] = useState<boolean>(false);
            
      
      const [DecsriptionProbleme, setDecsriptionProbleme] = useState<string>("");
          const handleSubmitTicket = async (e: FormEvent) => {
            e.preventDefault();
            const formData = new FormData();
            formData.append("NamUtilisateur", MagasinName?MagasinName:"");
            formData.append("probleme", Probleme);
            formData.append("description", DecsriptionProbleme);
            formData.append("Status", "Not Readable");
        try {
          const { data } = await axios.post(
            `${process.env.REACT_APP_PHP_APP_URL}/magasin/${MagasinId}/ticket/send`,
            formData
          );
        
                setShowSuccessPopup(true);
                const timeoutId = setTimeout(() => {
                        setShowSuccessPopup(false);
                      }, 2000);      
        
        } catch (error: unknown) {
          setShowErreurPopup(true);
        
          const timeoutId = setTimeout(() => {
            setShowErreurPopup(false);
          }, 2000);
        }
        }
    return<>
    <SideBareMagasin/>
        {showSuccessPopup && (
        <div className="popup-success">
          <div className="popup-content">
            <div className="popup-icon">
              <i className="bi bi-check-circle-fill"></i>
            </div>
            <h5>Votre ticket envoyé avec succès</h5>
            <p>Vous recevrez une réponse dans les brefs délais </p>
          </div>
        </div>
      )}
                    {ShowErreurPopup && (
        <div className="popup-success">
          <div className="popup-content">
            <div className="popup-icon">
              <i className="bi bi-exclamation-triangle-fill" style={{color:"red"}}></i>
            </div>
            <h5>Erreur de l'envoi</h5>
            <p>veillez entrer tout les information </p>
          </div>
        </div>
      )}
            <div className="popup-admin-overlay">
              <div className="popup-mags-container">
                <div className="popup-admin-header">
    <Link className="gere-ticket-magasin" to="/magasins/tickets">
      Gérée vos tickets
    </Link>              <h2>Créer un Ticket <i className="bi bi-ticket-perforated-fill popup-admin-icon"></i></h2>
                  <p>Décrivez votre problème et nous vous aiderons rapidement</p>
                </div>
    
                <form onSubmit={handleSubmitTicket} className="popup-admin-form">
                  <div className="form-group">
                    <label>Problème *</label>
                    <input
                      type="text"
                      placeholder="Résumez brièvement votre problème..."
                      value={Probleme}
                      onChange={(e) => setProbleme(e.target.value)}
                    />
                  </div>
    
                  <div className="form-group">
                    <label>Description du problème *</label>
                    <textarea
                      placeholder="Décrivez en détail votre problème..."
                      value={DecsriptionProbleme}
                      onChange={(e) => setDecsriptionProbleme(e.target.value)}
                    ></textarea>
                  </div>
    
                  <button type="submit" className="submit-btn">
                    <i className="bi bi-send"></i> Créer le Ticket
                  </button>
                </form>
              </div>
            </div>
    </>
}